// 学生考试记录
import request from '@/router/axios';

let urlPrefix = '/api/exam/etuserexamhistory';

/**
 * 分页查询学生考试列表
 * @param {Number} limit 每页条目数
 * @param {Number} page 当前页码
 * @param {Object} params 其他参数
 */
export const getStudentsExam = (page = 1, limit = 10, params = {}) => {
    return request(`${urlPrefix}/getStudentsExam`, { params: {
        limit,
        page,
        ...params
    } });
};

/**
 * 分页查询考试下学生列表
 * @param {Object} params 入参
 * @param {Number} params.limit 每页条目数
 * @param {Number} params.page 当前页码
 * @param {Number} params.examId 考试id
 */
export const getExamStudents = (params = {
    limit: 12,
    page: 1,
    examId: 0
}) => {
    return request(`${urlPrefix}/getExamStudents`, { params });
};

/**
 * 通过id获取实体
 * @param {Number} id 学生考试记录id
 */
export const getUserExamHistory = id => {
    return request(`${urlPrefix}/${id}`);
};
